<template>
  <div class="goodsItem" @click="()=>{this.$emit('isDetails',item)}">
    <div class="goodsImg" >
      <img v-lazy="item.img_url" alt=""/>
      <span class="goodsTraffic">
        <i class="el-icon-view"></i>
        {{item.click}}
      </span>
    </div>
    <h5>{{item.proname_cn}}</h5>
    <div class="tabel">
      <div class="tabelContent">
        <span>{{item.class_name_cn}}</span>
      </div>
      <div class="love_icon" @click.stop>
        <img v-if="item.coll==1" @click="cancel(item)" slot="reference" v-lazy="hrefurl+'/public/icon/like.png'" alt=""/>
        <el-popconfirm
          v-else
          title="确定要取消收藏吗？"
          @onConfirm='cancel(item)'
        >
          <img slot="reference" v-lazy="hrefurl+'/public/icon/like_1.png'" alt=""/>
        </el-popconfirm>
      </div>
     </div>
    <p class="corpname" @click.stop="exhJump(item)">{{item.corpname_cn}}</p>

    <div class="new" v-if="item.new">
      <img v-lazy="hrefurl+'/public/exhibit/new.png'" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {reqProCollDo, } from "../../../api"
export default {
  props:{
    item:Object,
    index:Number,
  },
  data(){
    return{
      flag:false
    }
  },
  methods:{
    async cancel(item){//取消收藏
      if (!(this.isLogin)) {
        this.isPath1(this)
        this.$store.dispatch("dialog",true)
      }else{//切换收藏状态
        const response = await reqProCollDo(item.id)
        if (response.code==0) {
          this.$emit("modifyColl",this.index)
        }
      }
    },

    exhJump(item){//详情页跳转
      if (!(this.isLogin)) {
        this.isPath1(this)
        this.$store.dispatch("dialog",true)
      }else{
        this.$router.push('/exhibitor/details/'+item.fk_oeid+'/'+item.ocid)
      }
    }
  },
  computed:{
    ...mapState({
      isLogin:state=>state.user.isLogin,
    }),
  }

}
</script>

<style scoped>
  .goodsItem{
    cursor: pointer;
    position: relative;
    border: 1px solid transparent;
    padding: 10px;
  }
  .goodsItem:hover{
    box-shadow: 3px 3px 8px 0 rgba(0,0,0,.1) ;
  }
  .goodsItem>h5{
    font-size: 16px;
    color: #333;
    line-height: 42px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: 600;
  }
  
  .goodsImg{
    width: auto;
    overflow: hidden;
    /* padding: 5%; */
    height: 210px;
    position: relative;
  }
  .goodsImg>img{
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: scale(1);
  }
  .goodsImg>img:hover{
    transform: scale(1.2);
    transition: all .5s;
  }
  .goodsTraffic{
    position: absolute;
    right: 4px ;
    bottom: 4px;
    font-size: 12px;
    vertical-align: middle;
    line-height: 1;
    color: #008baf;
    display: none;
  }
  .goodsTraffic i{
    font-size: 14px;
    vertical-align: top;
  }
  .goodsItem .tabel{
    padding-bottom: 6px;
  }
  .tabel .tabelContent{
    width: calc(100% - 24px);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
  }
  .tabelContent>span{
    display: inline-block;
    padding: 0 6px;
    line-height: 24px;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    background-color: #e6e6e6;
  }
  .tabel .love_icon{
    float: right;
    width: 20px;
    vertical-align: middle;
  }
  .goodsItem>.corpname{
    border-top: 1px solid #e6e6e6;
    color: #9fa0a0;
    font-size: 12px;
    line-height: 42px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    letter-spacing: .0em;
  }
  .new{
    position: absolute;
    left: 0;
    top: 0;
    width: 40px;
  }
  .goodsItem>.corpname:hover,
  .goodsItem>h5:hover{
    color: #008baf;
  }
</style>